import React, { useEffect, useState } from 'react'
import JSONPretty from 'react-json-pretty'
import { Button } from '@mui/material'
import Loading from '../../../Loading'

interface Props {
  sessionID: string
  fileName: string
  connected: boolean
  closeStream: any
  startStream: any
  deploySelected: string
}

// /**
//  * Component for displaying live MQTT data.
//  *
//  * @extends React.Component
//  *
//  * @param {Object} props - Component props.
//  * @param {string} props.sessionID - The session ID.
//  * @param {string} props.fileName - The name of the file for live data.
//  * @param {boolean} props.connected - Indicates if the MQTT client is connected.
//  *
//  * @property {string[]} state.mqttData - An array of MQTT data messages.
//  * @property {number | null} state.interval - The interval for updating the component.
//  * @property {Object | null} state.mqttClient - The MQTT client instance.
//  *
//  * @method componentWillUnmount - Lifecycle method to clean up resources when unmounting the component.
//  * @method componentDidMount - Lifecycle method to initialize the MQTT listener and update the component.
//  * @method initListener - Initializes and configures the MQTT client to listen for messages.
//  * @method eventMarkers - Generates React elements for MQTT data messages.
//  * @method render - Renders the component with MQTT data.
//  */
function LiveData({ sessionID, fileName, connected, closeStream, startStream, deploySelected }: Props) {
  const [messages, setMessages] = useState<any>([])
  const [isRunning, setIsRunning] = useState<boolean>(true)
  // const [socket, setSocket] = useState<any>(null);

  useEffect(() => {
    if (connected) {
      const ws: any = new WebSocket('ws://localhost:4000/mqttapi/ws')
      // setSocket(ws);

      ws.onopen = () => {
        if (ws) {
          const topic = `${sessionID}_${fileName}`
          ws.send(topic)
        }
      }

      ws.onmessage = (event: any) => {
        const newMessage = event.data
        setMessages((prevMessages:any) => [...prevMessages, newMessage])
        // console.log(messages);
      }

      setTimeout(async () => {
        stopStreaming()
        setIsRunning(false)
      }, 5000)

      return () => {
        ws.close()
      }
    }
  }, [])

  const stopStreaming = async () => {
    await closeStream(deploySelected)
    setIsRunning(false)
  }
  const runStreaming = async () => {
    await startStream(deploySelected)
    setIsRunning(true)
    setTimeout(async () => {
      await closeStream(deploySelected)
      setIsRunning(false)
    }, 5000)
  }

  const clearResult = () => {
    setMessages([])
  }

  return (
    <div>
      <div style={{ display: 'flex', justifyContent: 'space-around' }}>
        {isRunning ? <Button onClick={stopStreaming}>Stop</Button> : <Button onClick={runStreaming}>Run</Button>}
        <Button onClick={clearResult}>Clear Result</Button>
      </div>
      {messages.length === 0 && isRunning && (
        <div>
          <Loading action={'Running...'} />
        </div>
      )}
      <div>
        {messages.map((data:any, idx:any) => {
          return (
            <>
              <div key={`--mqttdata-${idx}-${idx}`}>
                <JSONPretty id="json-pretty-live" data={data} keyStyle="font-size:1.1em;color:#f92672;"></JSONPretty>
              </div>
              <hr />
            </>
          )
        })}
      </div>
    </div>
  )
}

export default LiveData

// ! https://github.com/mqttjs/MQTT.js/issues/1412
// ! https://github.com/mqttjs/MQTT.js/issues/1020
